import { render } from "./MainSidebar.vue?vue&type=template&id=7d97fe7c&scoped=true"
import script from "./MainSidebar.vue?vue&type=script&lang=js"
export * from "./MainSidebar.vue?vue&type=script&lang=js"

import "./MainSidebar.vue?vue&type=style&index=0&id=7d97fe7c&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d97fe7c"]])

export default __exports__